import * as React from "react";
import { useState } from "react";
import { InputGroup, Menu, MenuItem, Icon, Popover, Position } from "@blueprintjs/core";

export default function ScrollableDropdown({
  label,
  items = [],
  getKey = item => item?.id,
  getLabel = item => String(item),
  onSelect = () => { },
  enableSearch = false,
  onSearch,
  width = 250,
  renderItem,
  isItemDisabled,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");

  const getPortalContainer = () => {
    if (typeof document === "undefined") return undefined;
    let container = document.getElementById("peoplegoal-portal-container");
    if (!container) {
      container = document.createElement("div");
      container.id = "peoplegoal-portal-container";
      document.body.appendChild(container);
    }
    container.style.position = "absolute";
    container.style.top = "0";
    container.style.left = "0";
    container.style.zIndex = "9999";
    return container;
  };

  const handleClose = () => setIsOpen(false);

  const normalizedQuery = query.trim().toLowerCase();
  const visibleItems =
    enableSearch && normalizedQuery.length > 0
      ? items.filter(item =>
        (getLabel(item) || "")
          .toString()
          .toLowerCase()
          .includes(normalizedQuery)
      )
      : items;

  const handleSearchChange = e => {
    const value = e.target.value;
    setQuery(value);
    if (onSearch) onSearch(value);
  };

  return (
    <div style={{ width: "100%", maxWidth: `${width}px` }}>
      <Popover
        isOpen={isOpen}
        onInteraction={(nextOpenState) => setIsOpen(nextOpenState)}
        position={Position.BOTTOM_LEFT}
        minimal={true}
        portalContainer={getPortalContainer()}
        wrapperTagName="div"
        targetTagName="div"
        content={
          <div
            style={{
              padding: "8px 0",
              width: `${width}px`,
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)",
              border: "1px solid #e6e8eb",
              overflow: "hidden"
            }}
          >
            {enableSearch && (
              <div style={{ padding: "8px 10px", borderBottom: "1px solid #eef0f2", backgroundColor: "white" }}>
                <InputGroup
                  leftIcon="search"
                  placeholder="Search"
                  value={query}
                  onChange={handleSearchChange}
                  style={{ boxShadow: "none" }}
                />
              </div>
            )}
            <div style={{ maxHeight: enableSearch ? "300px" : "344px", overflowY: "auto" }}>
              <Menu>
                {visibleItems.length > 0 ? (
                  visibleItems.map(item => (
                    <MenuItem
                      key={getKey(item)}
                      text={renderItem ? renderItem(item) : getLabel(item)}
                      disabled={isItemDisabled ? isItemDisabled(item) : false}
                      onClick={() => {
                        if (isItemDisabled?.(item)) return;

                        onSelect(item);
                        handleClose();
                        setQuery("");
                        if (onSearch) onSearch("");
                      }}
                    />
                  ))
                ) : (
                  <div
                    style={{
                      padding: "12px",
                      textAlign: "center",
                      color: "#929292",
                      fontSize: "13px"
                    }}
                  >
                    No data found
                  </div>
                )}
              </Menu>
            </div>
          </div>
        }
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            boxSizing: "border-box",
            padding: "9px 14px",
            backgroundColor: "white",
            borderRadius: "20px",
            cursor: "pointer",
            boxShadow: "0 0 0 1px #ccc"
          }}
        >
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flexGrow: 1,
              marginRight: "10px"
            }}
            title={label}
          >
            {label}
          </div>
          <Icon icon="caret-down" />
        </div>
      </Popover>
    </div>
  );
}
